import { setTag } from '@sentry/react'

export function setIsBec(flag: boolean) {
	setTag('isBec', flag)
}
export function setIsNets(flag: boolean) {
	setTag('isNets', flag)
}
export function setIsDanskeBank(flag: boolean) {
	setTag('isDanskeBank', flag)
}
export function setIsBankData(flag: boolean) {
	setTag('isBankData', flag)
}
export function setIsAiia(flag: boolean) {
	setTag('isAiia', flag)
}
export function setIsNordea(flag: boolean) {
	setTag('isNordea', flag)
}
export function setIsSDC(flag: boolean) {
	setTag('isSDC', flag)
}
export function setIsLunar(flag: boolean) {
	setTag('isLunar', flag)
}
export function setIsEnableBanking(flag: boolean) {
	setTag('isEnableBanking', flag)
}
export function setIsSwedbank(flag: boolean) {
	setTag('isSwedbank', flag)
}
export function setIsDnb(flag: boolean) {
	setTag('isDnb', flag)
}

export function SetInitialSentryTags() {
	setTag('redirect-receiver', true)
	setIsBec(false)
	setIsNets(false)
	setIsDanskeBank(false)
	setIsBankData(false)
	setIsNordea(false)
}
